export const VERIFICATION_CLOSE_FETCH = 'VERIFICATION_CLOSE_FETCH';
export const VERIFICATION_CLOSE_FETCH_ERROR = 'VERIFICATION_CLOSE_FETCH_ERROR';
export const VERIFICATION_CLOSE_FETCHING = 'VERIFICATION_CLOSE_FETCHING';
export const VERIFICATION_CLOSE_SUBMITTING = 'VERIFICATION_CLOSE_SUBMITTING';
export const VERIFICATION_CLOSE_SUBMIT = 'VERIFICATION_CLOSE_SUBMIT';
export const VERIFICATION_CLOSE_SUBMIT_ERROR =
  'VERIFICATION_CLOSE_SUBMIT_ERROR';
export const VERIFICATION_CLOSE = 'VERIFICATION_CLOSE';



// WEBPACK FOOTER //
// ./src/pages/verificationclose/state/verificationclose/types.js